import CampaignCreationBrandSelection from 'Components/campaigns/create-edit/BrandSelection';
import CampaignCreationAIStrategies from 'Components/campaigns/create-edit/CampaignCreationAIStrategies';
import React, { useState } from 'react'
import { UserBrand } from 'types/users'

const CreateCampaignAIAuto = () => {

  const [selectedBrand, setSelectedBrand] = useState<UserBrand | null>(null);


  if (!selectedBrand) {
    return <CampaignCreationBrandSelection value={selectedBrand} onChange={setSelectedBrand} />
  }

  return (
    <>
      {selectedBrand && (
        <CampaignCreationAIStrategies
          key={selectedBrand.social_account?.uuid ?? ''}
          brandSocialAccountId={selectedBrand.social_account?.uuid ?? ''}
          onBrandChange={setSelectedBrand}
        />
      )}

    </>
  )
}

export default CreateCampaignAIAuto